<template>
  <el-dialog
    ref="dialog"
    v-dialogDrag
    :title="dialogTitle"
    :visible.sync="dialogVisible"
    class="data_list_dialog"
    width="1200px"
    :before-close="modalClose"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    append-to-body
    @open="handleOpen('dialog')"
  >
    <div class="container-box">
      <!-- 查询条件 -->
      <div
        ref="searchCondition"
        class="search-condition"
      >
        <el-row :gutter="10">
          <el-col style="width:60px;padding-left:10px;">
            <el-button
              type="text"
              style=""
            >
              查询条件：
            </el-button>
          </el-col>
          <el-col :span="4">
            <el-input
              v-model="tableList.tableQuery.search.certificateNo"
              placeholder="请输入专卖证号"
              style="width:100%"
              clearable
              @keyup.enter.native="loadTableData"
            />
          </el-col>
          <el-col :span="4">
            <el-input
              v-model="tableList.tableQuery.search.storeName"
              placeholder="请输入专卖证号"
              style="width:100%"
              clearable
              @keyup.enter.native="loadTableData"
            />
          </el-col>
          <el-col :span="5">
            <el-button
              type="primary"
              @click="searchData(tableList)"
            >
              查询
            </el-button>
          </el-col>
        </el-row>
      </div>
      <!-- 数据列表 -->
      <div class="table-wrap table-list-show">
        <custom-table
          :ref="tableList.tableKey"
          :table-key="tableList.tableKey"
          :data-obj="tableList"
          :table-columns="tableList.tableColumns"
          :table-data="tableList.tableData"
          :loading="tableList.tableLoading"
          :search-condition.sync="tableList.tableQuery"
          :table-custom-height="tableHeight"
          :is-paging="isPaging"
          is-index-field
          is-select-field
          :multiple-selection.sync="multipleSelection"
          :data-total="tableList.tableDataTotal"
          :table-contextmenu="tableList.tableContextmenu"
          @reloadData="loadTableData(tableList)"
          @auditBill="auditBillFun()"
        />
      </div>
      <!-- 新增 修改-->
      <add-edit-view-dialog
        :event-type="'audit'"
        :data-id="billId"
        :dialog-title="dialogAddEditTitle"
        :dialog-visible.sync="dialogAddEditVisible"
        :master-table-key="tableList.tableKey"
        @reloadData="reloadMasterData()"
      />
    </div>
  </el-dialog>
</template>
<script>
// 自定义Table
import CustomTable from '@/components/CustomTable'
// 计算表格高度，搜索，获取数据Mixin
import dialogTableCustomMixin from '@/mixin/dialogTableCustomMixin'
// dialog 拖拽dialogDragMixin
import dialogDragMixin from '@/mixin/dialogDragMixin'
// 新增 修改 
import AddEditViewDialog from './addEditViewDialog'
import { loadTobaccoVisitListListDataApi } from '@/api/tobaccoVisitList'
export default {
  name: 'TobaccoVisitListExportAuditTaskList',
  components: { CustomTable,AddEditViewDialog },
  mixins: [dialogDragMixin, dialogTableCustomMixin],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    themeColor: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      customerName: '',
      tableList: {
        initTableColumn: [], // Table初始化列
        tableColumns: [], // Table列
        tableKey: 'tobacco_visit_list_audit_task_master', // Table Key
        tableIndex: 0, // Table Index
        tableLoading: false, // Table加载状态
        tableData: [], // Table数据
        tableDataTotal: 0, // Table总数据条数
        // Table右键
        tableContextmenu: [
          {
            prop: 'add',
            label: '审核',
            method: 'auditBill'
          }
        ],
        tableQuery: {
          page: 1, // 页数
          limit: 50, // 每页条数
          contextmenuWrap: [], // 右键筛选字段
          sort: { // 排序对象
            prop: '', // 排序字段
            order: '' // 排序类型 ascending升序 descending降序
          },
          search: {
            certificateNo:'',
            auditStatus: 1
          }
        }
      },
      multipleSelection: [],
      isPaging: true,
      dialogAddEditTitle: '',
      dialogAddEditVisible: false,
      billId: null
    }
  },
  watch: {
    dialogVisible (val) {
      if (val) {
        this.tableList.initTableColumn = [
          { prop: 'schemeNo', label: '方案编号', filterColumn: 'scheme_no', width: 200 },
          { prop: 'visitDateStr', label: '计划拜访日期', filterColumn: 'visit_date', width: 140 },
          { prop: 'visitUser', label: '走访人', filterColumn: 'visit_user', width: 100 },
          { prop: 'certificateNo', label: '专卖证号', filterColumn: 'certificate_no', width: 160 },
          { prop: 'customerNo', label: '客户编码', filterColumn: 'customer_no', width: 160 },
          { prop: 'benxiangNo', label: '本香门店码', filterColumn: 'benxiang_no', width: 160 },
          { prop: 'storeName', label: '店名', filterColumn: 'store_name', width: 160 },
          { prop: 'storeSortStr', label: '零售户类型', filterColumn: 'store_sort', filterValue: 'storeSort', width: 140, filterArray: [{ label: '重点', value: 1 }, { label: '潜力', value: 3 }, { label: '信息', value: 4 }] },
          { prop: 'provinceName', label: '所在省区', filterColumn: 'province_name', width: 120 },
          { prop: 'cityName', label: '所在城市', filterColumn: 'city_name', width: 120 },
          { prop: 'countyName', label: '所在区县', filterColumn: 'county_name', width: 120 },
          { prop: 'linkman', label: '联系人', filterColumn: 'linkman', width: 120 },
          { prop: 'phone', label: '联系电话', filterColumn: 'phone', width: 120 },
          { prop: 'address', label: '地址', filterColumn: 'address', width: 160 },
          { prop: 'signInTimeStr', label: '签到时间', filterColumn: 'sign_in_time', width: 160 },
          { prop: 'signOutTimeStr', label: '走访完成时间', filterColumn: 'sign_out_time', width: 160 },
          { prop: 'duration', label: '在店时长(分钟)', filterColumn: 'duration', width: 150 },
          { prop: 'level', label: '档位', filterColumn: 'level', width: 120 },
          { prop: 'regionStr', label: '城市/农村', filterColumn: 'region', width: 120, filterArray: [{ label: '城市', value: 'C' }, { label: '农村', value: 'X' }] },
          { prop: 'businessStr', label: '业态', filterColumn: 'business', width: 120, filterArray: [{ label: '食杂店', value: 'Z' }, { label: '便利店', value: 'B' }, { label: '超市', value: 'S' }, { label: '商场', value: 'N' }, { label: '烟酒店', value: 'Y' }, { label: '娱乐服务', value: 'F' }, { label: '其他', value: 'Q' }] },
          { prop: 'scaleStr', label: '规模', filterColumn: 'scale', width: 120, filterArray: [{ label: '大', value: 1 }, { label: '中', value: 2 }, { label: '小', value: 3 }] },
          { prop: 'tag', label: '标签', filterColumn: 'tag', width: 120 },
          { prop: 'aiResult', label: 'AI识别结果', filterColumn: 'ai_result', width: 160 },
          { prop: 'matchResultStr', filterColumn: 'match_result', filterValue: 'matchResult', label: '匹配结果', width: 120, filterArray: [{ label: '匹配成功', value: 1 }, { label: '未匹配', value: 2 }, { label: '匹配失败', value: 3 }] },
        ]
        this.tableList.tableColumns = this.tableList.initTableColumn
        this.searchData(this.tableList)     
      }
    }
  },
  methods: {
    // 请求数据
    requestData () {
      this.tableList.tableLoading = true
      let pageCondition = { condition: JSON.stringify(this.tableList.tableQuery) }
      loadTobaccoVisitListListDataApi(pageCondition).then(response => {
        this.tableList.tableLoading = false
        let data = response.data.data ? response.data.data : []
        this.handleData(this.tableList,data)
        this.tableList.tableDataTotal = response.data.recordsTotal
      }).catch()
    },
    // 关闭弹框
    modalClose () {
      this.$emit('update:dialogVisible', false) // 直接修改父组件的属性
    },
    // 刷新列表
    reloadMasterData () {
      this.$emit('reloadData')
      this.loadTableData(this.tableList)
    },
    // 创建
    auditBillFun () {
      if (this.multipleSelection.length < 1) {
        this.$message({
          message: '请选择数据行',
          type: 'warning'
        })
        return false
      } else if (this.multipleSelection.length > 1){
        this.$message({
          message: '只能选择一条数据',
          type: 'warning'
        })
        return false
      } else {
        this.billId = this.multipleSelection[0].id
        this.dialogAddEditVisible = !this.dialogAddEditVisible
        this.dialogAddEditTitle = '审核中烟走访记录'
      }
    }
  }
}
</script>
<style lang="scss"  scoped>
.table-wrap {
  margin-top: 5px;
}
</style>
